import { newAxios } from "./index";


export const Req_GetExpenseList = data => {
  return newAxios({
    url: `/i/tenant/finance/expenses/page`,
    data
  })()
}

export const Req_SubmitExpense = (data) => {
  return newAxios({
    url: '/i/tenant/finance/expenses/save',
    data
  },'json')()
}

//获取出纳配置选择列表
export const Req_GetTellerSelectList = (data) => {
  return newAxios({
    url: '/i/tenant/finance/teller/config/select',
    data
  })()
}

//获取报销单详情，
export const Req_GetExpenseDetail = (data) => {
  return newAxios({
    url: '/i/tenant/finance/expenses/detail/id',
    data
  })()
}

//批量取消确认
export const Req_BatchCancelVerify = (data) => {
  return newAxios({
    url:`/i/tenant/finance/expenses/verify/cancel`,
    data
  },'json')()
}


//资金明细列表
export const Req_GetFundDetailList = (data) => {
  return newAxios({
    url: '/i/tenant/finance/teller/fund/pages',
    data
  },'json')()
}

//出纳配置列表
export const Req_GetConfigList = (data) => {
  return newAxios({
    url: '/i/tenant/finance/teller/config/page',
    data
  })()
}


//添加出纳配置
export const Req_AddConfig = (data) => {
  return newAxios({
    url: '/i/tenant/finance/teller/config/add',
    data
  },'json')()
}

//修改出纳配置
export const Req_EditConfig = (data) => {
  return newAxios({
    url: '/i/tenant/finance/teller/config/edit',
    data
  },'json')()
}

//删除出纳配置
export const Req_DelConfig = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/config/del/id`,
    data
  })()
}


//获取科目
export const Req_GetSubject = (data) => {
  return newAxios({
    url:`/i/tenant/finance/subject/bean/customer/last/list/lite`,
    data
  })()
}

//获取机构付款账户列表
export const Req_GetPaymentList = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/fund/payment/account/list`,
    data
  })()
}


//获取期间金额
export const Req_GetFundAmount = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/fund/pages/amount`,
    data
  },'json')()
}

//设置期初金额
export const Req_SetFundAmount = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/fund/payment/account/save`,
    data
  },'json')()
}


//打印
export const Req_Print = (data) => {
  return newAxios({
    url:`/i/tenant/finance/expenses/print`,
    data
  })()
}

//获取默认公司
export const Req_GetDefaultCompany = (data) => {
  return newAxios({
    url:`/i/tenant/finance/expenses/get/default/company`,
    data
  })()
}


//作废报销单
export const Req_CancelExpense = (data) => {
  return newAxios({
    url:`/i/tenant/finance/expenses/cancel/by/ids`,
    data
  },'json')()
}

//产品分类
export const Req_GetProductList = (data) => {
  return newAxios({
    url:`/i/tenant/crm/service/product/category/greater/two`,
    data
  })()
}

//批量确认报销单
export const Req_BatchConfirmExpense = (data) => {
  return newAxios({
    url:`/i/tenant/finance/expenses/verify/ids`,
    data
  })()
}


//获取收入分类列表
export const Req_GetIncomeConfig = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/config/classify/list`,
    data
  })()
}

//新增收入分类
export const Req_AddIncomeCategory = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/config/classify/save`,
    data
  },'json')()
}
//删除收入分类
export const Req_DelIncomeCategory = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/config/classify/del/id`,
    data
  })()
}


//获取统计配置表
export const Req_GetStatList = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/stat/config/list`,
    data
  })()
}


//保存统计配置表
export const Req_SaveStatList = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/stat/config/batch/save`,
    data
  },'json')()
}

//删除存统计配置
export const Req_DelStat = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/stat/config/del/id`,
    data
  })()
}

//保存收款单
export const Req_SaveRevenue = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/save`,
    data
  },'json')()
}

//获取收款分页
export const Req_GetRevenueList = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/page`,
    data
  })()
}

//获取收款单详情
export const Req_GetRevenueInfo = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/detail/id`,
    data
  })()
}

//批量确认收款单
export const Req_BatchVerifyRevenue = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/verify/ids`,
    data
  })()
}

//批量取消确认收款单
export const Req_BatchCancelRevenue = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/verify/cancel`,
    data
  },'json')()
}


//获取全部客户
export const Req_GetAllCustom = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/get/all/customer/info`
  })()
}


//订单生成收款单基本信息 
export const Req_OrderCreateRev = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/gen/by/order`,
    data
  },'json')()
}


//打印收款单
export const Req_PrintRevenue = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/print`,
    data
  })()
}

//生成代账类订单收款明细信息
export const Req_GetDetailByOrder = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/gen/detail/by/order`,
    data
  })()
}


//获取单据号
export const Req_GetReceiptNumber = (data) => {
  return newAxios({
    url:`/i/tenant/finance/teller/receipt/number/get`,
    data
  })()
}

//批量作废收款单
export const Req_BatchInvalRevenue = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/cancel/by/ids`,
    data
  },'json')()
}

//批量作废收款单
export const Req_InvalNumber = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/receipt/number/cancel`,
    data
  })()
}

//订单收款记录生成收款单基本信息
export const Req_RecordCreateRec = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/gen/by/settle/record`,
    data
  })()
}

//生成红冲 退款单
export const Req_CreateOffSet = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/gen/red/offset/or/refund`,
    data
  },'json')()
}
//生成代账类订单退款明细
export const Req_GetDetailByRefund = (data) => {
  return newAxios({
    url:`/i/tenant/finance/revenue/gen/refund/details`,
    data
  })()
}

//订单退款记录（新）
export function Req_GetRefundRecord(data) {
  return newAxios({
    url: `/i/tenant/crm/service/order/search/refund`,
    data
  })()
}

//获取资金明细 某列用于filter 的option
export function Req_GetFundColumnOptions(data) {
  return newAxios({
    url: `/i/tenant/finance/teller/fund/column/pages`,
    data
  },'json')()
}

export const Req_GetBillReceivalbeTable = data => {
  return newAxios({
    url: `/i/tenant/hr/accrual/customer/receivable/info/summary`,
    data: {
      ...data,

    }
  },'json')()
}

export const Req_GetBillReceFilterObject = data => {
  return newAxios({
    url: `/i/tenant/crm/filter/list/by/object`,
    data: {
      filterObject: 50
    }
  })()
}

export const Req_UpdateBillReceivalbeItem = data => {
  return newAxios({
    url: `/i/tenant/hr/accrual/save/customer/receivable/info`,
    data
  },'json')()
}

export const Req_ExportBillReceTable = data => {
  return newAxios({
    url: `/i/tenant/hr/accrual/export/customer/receivable/info`,
    data
  },'json')()
}


// WEBPACK FOOTER //
// ./src/request/finance.js